import { render } from "./FireAvatar.vue?vue&type=template&id=22ed2f9a&scoped=true"
import script from "./FireAvatar.vue?vue&type=script&lang=ts"
export * from "./FireAvatar.vue?vue&type=script&lang=ts"

import "./FireAvatar.vue?vue&type=style&index=0&id=22ed2f9a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-22ed2f9a"

export default script